export const buttonVariants = {
  primary:
    "bg-primary text-white hover:bg-opacity-90 border border-primary hover:border-opacity-80 shadow-md hover:shadow-xl",
  secondary:
    "bg-white text-primary hover:bg-primary hover:text-white border border-primary transition-colors",
  outline:
    "bg-transparent text-primary hover:bg-primary hover:text-white border-2 border-primary",
  ghost:
    "bg-transparent text-primary hover:bg-primary/10 border border-transparent hover:border-primary/20",
  danger:
    "bg-red-500 text-white hover:bg-red-600 border border-red-500 hover:border-red-600 shadow-md hover:shadow-xl",
  success:
    "bg-green-500 text-white hover:bg-green-600 border border-green-500 hover:border-green-600 shadow-md hover:shadow-xl",
  cancel:
    "bg-gray-50 text-gray-700 hover:bg-gray-300 border border-gray-300 shadow-md hover:shadow-xl",
};
